import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Toolbar, Typography } from "@mui/material";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import Vehiclerevenuedashboard from "./Vehiclerevenuedashboard";

const Vehiclerevenuemodule = () => {
  const navItems = routeModules?.vehiclerevenue?.sidebar || [];
  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    switch (activeItem) {
      case "Dashboard":
        return <Vehiclerevenuedashboard />;
      default:
        return (
          <div className="p-8 text-center bg-white rounded-2xl border border-gray-100 shadow-sm mt-4">
            <Typography className="text-gray-500 font-medium">Access Restriction Protocol Active</Typography>
          </div>
        );
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500); // Optimized delay for smoother transition
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }} className="bg-slate-50 min-h-screen">
      <CssBaseline />
      <Layout
        module={"vehiclerevenue"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      
      {/* Refactored main block wrapper container context.
        Removed width: "50%" bottleneck to grant full canvas fluid layout execution.
      */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          width: "100%", 
          overflowX: "hidden"
        }}
      >
        <Toolbar />
        <div className="w-full flex-1">
          {renderContent()}
        </div>
      </Box>
    </Box>
  );
};

export default Vehiclerevenuemodule;